module.exports = __webpack_public_path__ + "static/media/microscope-02.26c62e03.PNG";